import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, Link } from 'react-router-dom';
import { fetchProductById, clearProduct } from './productSlice';
import { addToCart } from '../reducer/slices/cartSlice';
import MarketplaceNavbar from '../../components/MarketplaceNavbar'
import { makeAuthenticatedGETRequest, makeAuthenticatedPATCHRequest } from '../services/serverHelper';
import { productPoints } from '../services/apis';
import ProductCard from '../../components/ProductCard';
import "./ProductDetails.css";
import { toast, ToastContainer } from "react-toastify";


const ProductDetails = () => {
  const params = useParams();
  const dispatch = useDispatch();
  const {accessToken} = useSelector(state => state.auth);
  const [isDisabled, setIsDisabled] = useState(false);
  const [product, setProduct] = useState([])
  const cart = localStorage.getItem('cart')

  useEffect(() => {
    fetchItem()

  }, []);

  const fetchItem = async() => {
    const response = await makeAuthenticatedGETRequest(
      `${productPoints.FETCH_PUBLIC_ONE_PRODUCTS_API}/${params.id}`, 
      accessToken
    )
    // if(cart.some(item => item._id === response.data._id)){
    if(cart.includes(response.data._id)){
      setIsDisabled(true)
    }

    setProduct(response.data);
  }

  const handleAddToCart = async() => {
    const response = await makeAuthenticatedPATCHRequest(
          `${productPoints.PUSH_CART_ITEMS}`,
          {productId: product._id, userId: localStorage.getItem('artId')},
          accessToken
        )
        console.log(response)
    
        if(response.statusCode === 200){
          dispatch(addToCart(product));
          setIsDisabled(true);
          toast.success("Product added to cart.");
        }else{
          toast.error("Product not added to cart.")
        }
  };

  const handlePurchase = () =>{}


  return (
    <div>
      <MarketplaceNavbar />
        <div className='products-main'>
        
      {product.length === 0 ? (
          <div className="text-center">
            <p>No products available.</p>
          </div>
        ) : (
          <div className="product-details-container">
            <div className="product-details-card">

              {/* Product Images */}
              <div className="product-image-section">
                  <iframe
                      title='Youtube player'
                      className="product-card-img-top-description"
                      // sandbox='allow-same-origin allow-forms allow-popups allow-scripts allow-presentation'
                      src={`https://youtube.com/embed/${product.video.youtubeTrailerId}?autoplay=0`}>
                  </iframe>
              </div>

              {/* Product Info */}
              <div className="product-info-section">

                <span className="product-category">
                  {product.category}
                </span>

                <h1 className="product-title">
                  {product.title}
                </h1>

                <div className="product-rating">
                  ⭐ {product.rating} ({product.totalReviews} Reviews)
                </div>

                <div className="product-price-section">
                  {/* <span className="discount-price">
                    ₹{product.discountPrice}
                  </span> */}

                  <span className="original-price">
                    ₹{product.pricing.amount}
                  </span>

                  {/* <span className="discount-percent">
                    {product.discountPercentage}% OFF
                  </span> */}
                </div>

                <p className="product-description">
                  {product.description}
                </p>

                {/* Product Specifications */}
                <div className="product-specifications">
                  <h3>Specifications</h3>

                  <div className="spec-row">
                    <span>Artist: </span>
                    <p>
                      <span>{product.artist.firstName} </span>
                      <span>{product.artist.lastName}</span>
                    </p>
                  </div>

                </div>

                {/* Buttons */}
                <div className="product-action-buttons">
                  <button className="add-to-cart-btn" style={{backgroundColor:isDisabled ? "#bbb7b7": "#65aef7"}} disabled={isDisabled} onClick={handleAddToCart}>
                    Add to Cart
                  </button>

                  {/* <button className="buy-now-btn" onClick={handlePurchase}>
                    Buy Now
                  </button> */}
                </div>

              </div>
            </div>
          </div>
                
              )} 
            {/* </div> */}
            </div>
          </div>
  );
};

export default ProductDetails;